<template>
  <div id="app">
    <GlobalLayout>
      <router-view/>
    </GlobalLayout>
  </div>
</template>

<style>
html, body{
  width: 100%;
  background-color: #030114!important;
  scroll-behavior: smooth;
}
body{
  width: 100%;
  height: auto!important;
  overflow: auto;
}
#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import GlobalLayout from "@/layout/GlobalLayout.vue";
export default {
  components: {
    GlobalLayout
  }
}
</script>
